import {ReactNode, useRef, useState} from 'react';

import {GeneratedPlatformDescription} from '@dms/api/sales';

import {GeneratedDescriptionsContextProvider} from '../contexts/GeneratedDescriptionsContext';

export const GeneratedDescriptionsContext = ({children}: {children: ReactNode}) => {
  const [generatedPlatformDescriptions, setGeneratedPlatformDescriptions] = useState<
    GeneratedPlatformDescription[] | null
  >(null);

  const formSubmitRef = useRef<(() => Promise<boolean>) | null>(null);
  const isDirtyRef = useRef(false);

  const resetGeneratedPlatformDescriptions = () => setGeneratedPlatformDescriptions(null);

  return (
    <GeneratedDescriptionsContextProvider
      value={{
        generatedPlatformDescriptions,
        setGeneratedPlatformDescriptions,
        resetGeneratedPlatformDescriptions,
        formSubmitRef,
        isDirtyRef,
      }}
    >
      {children}
    </GeneratedDescriptionsContextProvider>
  );
};
